import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=7ced4ac6&"
import script from "./infoCard.vue?vue&type=script&lang=js&"
export * from "./infoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports